var pixelRatio = window.devicePixelRatio ? window.devicePixelRatio : 1;
function carouselSlider(t) {
  var e = t,
    i = e.parent().find(".data-carousel");
  if (i.data("auto"))
    var n = !0,
      o = i.data("auto");
  else (n = !1), (o = 5e3);
  var a = i.data("320") ? i.data("320") : 1,
    r = i.data("480") ? i.data("480") : 1,
    s = i.data("640") ? i.data("640") : 1,
    c = i.data("768") ? i.data("768") : 1,
    l = i.data("992") ? i.data("992") : 1,
    d = i.data("1200") ? i.data("1200") : 1,
    u = i.data("1600") ? i.data("1600") : i.data("1200");
  e.owlCarousel({
    items: i.data("items"),
    smartSpeed: 500,
    autoplay: n,
    lazyLoad: !0,
    autoplayTimeout: o,
    autoplayHoverPause: !0,
    loop: i.data("loop") !== false,
    dots: i.data("paging"),
    margin: i.data("margin"),
    nav: i.data("nav"),
    navText: [i.data("prev"), i.data("next")],
    responsive: {
      0: { items: a },
      480: { items: r },
      640: { items: s },
      768: { items: c },
      992: { items: l },
      1200: { items: d },
      1600: { items: u },
    },
  }),
    e.on("changed.owl.carousel", function (t) {
      var i = t.item.index,
        n = e.find(".owl-item")[i];
      e.find(".owl-item").removeClass("current"), $(n).addClass("current");
    }),
    i.data("navcustom") &&
      ($(i.data("navcustom") + " .owl-next").click(function () {
        e.trigger("next.owl.carousel");
      }),
      $(i.data("navcustom") + " .owl-prev").click(function () {
        e.trigger("prev.owl.carousel");
      }));
}
function productGridSetup() {
  $(".category-products .products-grid li.item:nth-child(2n)").addClass(
    "nth-child-2n"
  ),
    $(".category-products .products-grid li.item:nth-child(2n+1)").addClass(
      "nth-child-2np1"
    ),
    $(".category-products .products-grid li.item:nth-child(3n)").addClass(
      "nth-child-3n"
    ),
    $(".category-products .products-grid li.item:nth-child(3n+1)").addClass(
      "nth-child-3np1"
    ),
    $(".category-products .products-grid li.item:nth-child(4n)").addClass(
      "nth-child-4n"
    ),
    $(".category-products .products-grid li.item:nth-child(4n+1)").addClass(
      "nth-child-4np1"
    ),
    $(".category-products .products-grid li.item:nth-child(5n)").addClass(
      "nth-child-5n"
    ),
    $(".category-products .products-grid li.item:nth-child(5n+1)").addClass(
      "nth-child-5np1"
    ),
    $(".category-products .products-grid li.item:nth-child(6n)").addClass(
      "nth-child-6n"
    ),
    $(".category-products .products-grid li.item:nth-child(6n+1)").addClass(
      "nth-child-6np1"
    ),
    $(".category-products .products-grid li.item:nth-child(7n)").addClass(
      "nth-child-7n"
    ),
    $(".category-products .products-grid li.item:nth-child(7n+1)").addClass(
      "nth-child-7np1"
    ),
    $(".category-products .products-grid li.item:nth-child(8n)").addClass(
      "nth-child-8n"
    ),
    $(".category-products .products-grid li.item:nth-child(8n+1)").addClass(
      "nth-child-8np1"
    );
}
function colorSwatchGrid() {
  $(".configurable-swatch-list li a").on("mouseenter", function (t) {
    t.preventDefault(),
      $(this)
        .parents(".item-area")
        .find(".product-image-area")
        .find(".product-image")
        .find("img.main")
        .attr("src", $(this).data("image"));
  });
}
function productReview() {
  $(".spr-badge").length > 0 &&
    (SPR.registerCallbacks(),
    SPR.initRatingHandler(),
    SPR.initDomEls(),
    SPR.loadProducts(),
    SPR.loadBadges());
}
function qtyInit() {
  $(".qtyplus").click(function (t) {
    t.preventDefault();
    var e = parseInt(
      $(this).parent("form").find('input[name="quantity"]').val()
    );
    isNaN(e)
      ? $(this).parent("form").find('input[name="quantity"]').val(0)
      : $(this)
          .parent("form")
          .find('input[name="quantity"]')
          .val(e + 1);
  }),
    $(".qtyminus").click(function (t) {
      t.preventDefault(), (fieldName = $(this).attr("field"));
      var e = parseInt(
        $(this).parent("form").find('input[name="quantity"]').val()
      );
      !isNaN(e) && e > 0
        ? $(this)
            .parent("form")
            .find('input[name="quantity"]')
            .val(e - 1)
        : $(this).parent("form").find('input[name="quantity"]').val(0);
    });
}
function countDownInit() {
  $(".product-date").length > 0 &&
    $(".product-date").each(function (t, e) {
      var i = $(e).attr("data-date"),
        n = {
          yearText: window.date_text.year_text,
          monthText: window.date_text.month_text,
          weekText: window.date_text.week_text,
          dayText: window.date_text.day_text,
          hourText: window.date_text.hour_text,
          minText: window.date_text.min_text,
          secText: window.date_text.sec_text,
          yearSingularText: window.date_text.year_singular_text,
          monthSingularText: window.date_text.month_singular_text,
          weekSingularText: window.date_text.week_singular_text,
          daySingularText: window.date_text.day_singular_text,
          hourSingularText: window.date_text.hour_singular_text,
          minSingularText: window.date_text.min_singular_text,
          secSingularText: window.date_text.sec_singular_text,
        },
        o =
          '<div class="day"><span class="no">%d</span><span class="text">%td</span></div><div class="hours"><span class="no">%h</span><span class="text">%th</span></div><div class="min"><span class="no">%i</span><span class="text">%ti</span></div><div class="second"><span class="no">%s</span><span class="text">%ts</span></div>';
      if (i) {
        var a = { date: i };
        $.extend(a, n), (a.template = o), $(e).countdown(a);
      }
    });
}
function verticalCarosel(t) {
  var e = t.find(".verticl-carousel a").length;
  getThumb(t),
    e <= 3 && t.find(".more-views-nav").hide(),
    t.find(".more-views-prev").on("click", function () {
      if (!t.find(".verticl-carousel").is(":animated")) {
        var e = t.find(".verticl-carousel > a:last-child");
        t
          .find(".verticl-carousel > a:last-child")
          .clone()
          .prependTo(t.find(".verticl-carousel")),
          t
            .find(".verticl-carousel")
            .animate({ top: "-=85" }, 0)
            .stop()
            .animate({ top: "+=85" }, 300, function () {
              e.remove();
            }),
          getThumb(t);
      }
    }),
    t.find(".more-views-next").on("click", function () {
      if (!t.find(".verticl-carousel").is(":animated")) {
        var e = t.find(".verticl-carousel > a:first-child");
        t
          .find(".verticl-carousel > a:first-child")
          .clone()
          .appendTo(t.find(".verticl-carousel")),
          t
            .find(".verticl-carousel")
            .animate({ top: "-=85" }, 300, function () {
              e.remove(),
                t.find(".verticl-carousel").animate({ top: "+=85" }, 0);
            }),
          getThumb(t);
      }
    });
}
function getThumb(t) {
  t.find(".product-image-thumbs a").click(function (t) {
    t.preventDefault(),
      $(this)
        .parents(".product-image-area")
        .find(".product-image")
        .find("img.main")
        .attr("src", $(this).data("image"));
  });
}
function createCookie(t, e, i) {
  var n;
  if (i) {
    var o = new Date();
    o.setTime(o.getTime() + 24 * i * 60 * 60 * 1e3),
      (n = "; expires=" + o.toGMTString());
  } else n = "";
  document.cookie = escape(t) + "=" + escape(e) + n + "; path=/";
}
function readCookie(t) {
  for (
    var e = escape(t) + "=", i = document.cookie.split(";"), n = 0;
    n < i.length;
    n++
  ) {
    for (var o = i[n]; " " === o.charAt(0); ) o = o.substring(1, o.length);
    if (0 === o.indexOf(e)) return unescape(o.substring(e.length, o.length));
  }
  return null;
}
function eraseCookie(t) {
  createCookie(t, "", -1);
}
(window.theme = window.theme || {}),
  $("#slideshow > div:gt(0)").hide(),
  setInterval(function () {
    $("#slideshow > div:first")
      .fadeOut(1e3)
      .next()
      .fadeIn(1e3)
      .end()
      .appendTo("#slideshow");
  }, 8e3),
  (window.theme = window.theme || {}),
  (theme.Sections = function () {
    (this.constructors = {}),
      (this.instances = []),
      $(document)
        .on("shopify:section:load", this._onSectionLoad.bind(this))
        .on("shopify:section:unload", this._onSectionUnload.bind(this))
        .on("shopify:section:select", this._onSelect.bind(this))
        .on("shopify:section:deselect", this._onDeselect.bind(this))
        .on("shopify:block:select", this._onBlockSelect.bind(this))
        .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
  }),
  (theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
    _createInstance: function (t, e) {
      var i = $(t),
        n = i.attr("data-section-id"),
        o = i.attr("data-section-type");
      if (((e = e || this.constructors[o]), !_.isUndefined(e))) {
        var a = _.assignIn(new e(t), { id: n, type: o, container: t });
        this.instances.push(a);
      }
    },
    _onSectionLoad: function (t) {
      var e = $("[data-section-id]", t.target)[0];
      e && this._createInstance(e);
    },
    _onSectionUnload: function (t) {
      this.instances = _.filter(this.instances, function (e) {
        var i = e.id === t.detail.sectionId;
        return i && _.isFunction(e.onUnload) && e.onUnload(t), !i;
      });
    },
    _onSelect: function (t) {
      var e = _.find(this.instances, function (e) {
        return e.id === t.detail.sectionId;
      });
      !_.isUndefined(e) && _.isFunction(e.onSelect) && e.onSelect(t);
    },
    _onDeselect: function (t) {
      var e = _.find(this.instances, function (e) {
        return e.id === t.detail.sectionId;
      });
      !_.isUndefined(e) && _.isFunction(e.onDeselect) && e.onDeselect(t);
    },
    _onBlockSelect: function (t) {
      var e = _.find(this.instances, function (e) {
        return e.id === t.detail.sectionId;
      });
      !_.isUndefined(e) && _.isFunction(e.onBlockSelect) && e.onBlockSelect(t);
    },
    _onBlockDeselect: function (t) {
      var e = _.find(this.instances, function (e) {
        return e.id === t.detail.sectionId;
      });
      !_.isUndefined(e) &&
        _.isFunction(e.onBlockDeselect) &&
        e.onBlockDeselect(t);
    },
    register: function (t, e) {
      (this.constructors[t] = e),
        $("[data-section-type=" + t + "]").each(
          function (t, i) {
            this._createInstance(i, e);
          }.bind(this)
        );
    },
  })),
  (window.theme = window.theme || {}),
  (theme.Header = (function () {
    return {
      init: function () {
        if (
          ($(".notice-toplink .btn-close").on("click", function () {
            createCookie("noticetoplink", "true", 1),
              $(".notice-toplink")
                .css({ opacity: 0, transition: "opacity 0.3s" })
                .slideUp(500),
              setTimeout(function () {
                $(".notice-toplink").hide();
              }, 700);
          }),
          null == readCookie("noticetoplink") && $(".notice-toplink").show(),
          $(".search-area a.search-icon").click(function (t) {
            $(".top-links-icon")
              .parent()
              .children("ul.links")
              .removeClass("show"),
              $("#search_mini_form").is(".show")
                ? $("#search_mini_form").removeClass("show")
                : $("#search_mini_form").addClass("show"),
              $("#mobile-search-area").is(".show")
                ? $("#mobile-search-area").removeClass("show")
                : $("#mobile-search-area").addClass("show"),
              t.stopPropagation();
          }),
          $(".top-links-icon").click(function (t) {
            $(".search-area a.search-icon")
              .parent()
              .children("#search_mini_form")
              .removeClass("show"),
              $(this).parent().children("ul.links").hasClass("show")
                ? $(this).parent().children("ul.links").removeClass("show")
                : $(this).parent().children("ul.links").addClass("show"),
              t.stopPropagation();
          }),
          $(".search-area a.search-icon")
            .parent()
            .click(function (t) {
              t.stopPropagation();
            }),
          $(".mini-cart").hover(
            function () {
              $(this).children().children(".cart-wrapper").fadeIn(200);
            },
            function () {
              $(this).children().children(".cart-wrapper").fadeOut(200);
            }
          ),
          $("html,body").click(function () {
            $(".top-links-icon")
              .parent()
              .children("ul.links")
              .removeClass("show"),
              $(".search-area a.search-icon")
                .parent()
                .children("#search_mini_form")
                .removeClass("show");
          }),
          $(".menu-icon, .mobile-nav-overlay").click(function (t) {
            $("body").hasClass("md-mobile-menu") ||
              $("body").addClass("md-mobile-menu"),
              $("body").hasClass("mobile-nav-shown")
                ? ($("body").removeClass("mobile-nav-shown"),
                  $(".mobile-nav").removeClass("show"))
                : $("body").addClass("mobile-nav-shown", function () {
                    setTimeout(function () {
                      $(document).one("click", function (t) {
                        var e = t.target;
                        $(e).is(".mobile-nav") ||
                          $(e).parents().is(".mobile-nav") ||
                          $("body").removeClass("mobile-nav-shown");
                      });
                    }, 111);
                  });
          }),
          $(".header-container .dropdown-menu .menu-container>a").click(
            function () {
              $(this).next().find(".side-menu").hasClass("show")
                ? $(this).next().find(".side-menu").removeClass("show")
                : $(this).next().find(".side-menu").addClass("show"),
                $(window).width() <= 991 &&
                  ($(".mobile-nav").hasClass("show")
                    ? ($(".mobile-nav").removeClass("show"),
                      $(".mobile-nav").slideUp(),
                      $("body").removeClass("mobile-nav-shown"))
                    : ($(".mobile-nav").addClass("show"),
                      $(".mobile-nav").slideDown(),
                      $("body").addClass("mobile-nav-shown", function () {
                        setTimeout(function () {
                          $(document).one("click", function (t) {
                            var e = t.target;
                            $(e).is(".mobile-nav") ||
                              $(e).parents().is(".mobile-nav") ||
                              $("body").removeClass("mobile-nav-shown");
                          });
                        }, 111);
                      })));
            }
          ),
          $(".template-index").find(".sidebar").length > 0)
        ) {
          var t = $(".template-index").find(".sidebar");
          $(t).hasClass("f-left") &&
            0 == $(".template-index").find(".header-container.type2").length &&
            (setTimeout(function () {
              $(t).css("padding-top", $(".side-menu").height() + 65);
            }, 300),
            $(window).resize(function () {
              $(t).css("padding-top", $(".side-menu").height() + 65);
            }));
        }
      },
      unload: function () {},
    };
  })()),
  (theme.HeaderSection = (function () {
    function t() {
      theme.Header.init();
    }
    return (
      (t.prototype = _.assignIn({}, t.prototype, {
        onUnload: function () {
          theme.Header.unload();
        },
      })),
      t
    );
  })()),
  (window.theme = window.theme || {}),
  (theme.Slideshow = (function () {
    function t() {
      var t = $(window).innerWidth(),
        e = $(window).innerHeight(),
        i = t / e,
        n = 320,
        o = 240;
      $(".full-screen-slider div.item").css("position", "relative"),
        $(".full-screen-slider div.item").css("overflow", "hidden"),
        $(".full-screen-slider div.item").width(t),
        $(".full-screen-slider div.item").height(e),
        $(".full-screen-slider div.item > video").css("position", "absolute"),
        $(".full-screen-slider div.item > video").bind(
          "loadedmetadata",
          function () {
            (n = this.videoWidth),
              (o = this.videoHeight),
              i >= n / o
                ? ($(this).width(t),
                  $(this).height(""),
                  $(this).css("left", "0px"),
                  $(this).css("top", (e - (t / n) * o) / 2 + "px"))
                : ($(this).width(""),
                  $(this).height(e),
                  $(this).css("left", (t - (e / o) * n) / 2 + "px"),
                  $(this).css("top", "0px")),
              $(this).get(0).play();
          }
        );
    }
    return (
      (this.$container = null),
      function (e) {
        if (
          ((this.$container = $(e)), this.$container.hasClass("owl-carousel"))
        ) {
          var i = this.$container.parent().find(".data-slideshow");
          if (i.data("auto"))
            var n = !0,
              o = i.data("auto");
          else (n = !1), (o = 5e3);
          if ("fade" == i.data("transition") && "" != i.data("transition"))
            var a = "fadeOut";
          else a = !1;
          this.$container.owlCarousel({
            items: 1,
            smartSpeed: 500,
            autoplay: n,
            lazyLoad: !0,
            autoplayTimeout: o,
            autoplayHoverPause: !0,
            animateOut: a,
            loop: !0,
            dots: i.data("paging"),
            nav: i.data("nav"),
            navText: [i.data("prev"), i.data("next")],
            thumbs: !0,
            thumbImage: !1,
            thumbsPrerendered: !0,
            thumbContainerClass: "owl-thumbs",
            thumbItemClass: "owl-thumb-item",
          });
        }
        this.$container.parents(".full-screen-slider").length > 0 &&
          (t(),
          $(window).resize(function () {
            t();
          }));
      }
    );
  })()),
  (theme.BrandSlider = (function () {
    return (
      (this.$container = null),
      function (t) {
        (this.$container = $(t)),
          this.$container.find(".owl-carousel").length > 0 &&
            carouselSlider(this.$container.find(".owl-carousel"));
      }
    );
  })()),
  (theme.CollectionSlider = (function () {
    return (
      (this.$container = null),
      function (t) {
        (this.$container = $(t)),
          this.$container.find(".owl-carousel").length > 0 &&
            carouselSlider(this.$container.find(".owl-carousel"));
      }
    );
  })()),
  (theme.CollectionProducts = (function () {
    return (
      (this.$container = null),
      function (t) {
        (this.$container = $(t)),
          this.$container.find(".owl-carousel").length > 0 &&
            this.$container.find(".owl-carousel").each(function () {
              carouselSlider($(this));
            }),
          this.$container
            .find(".lazy")
            .lazyload({ effect: "fadeIn", data_attribute: "src" }),
          this.$container.find(".category-products .products-grid").length >
            0 && productGridSetup(),
          productReview(),
          countDownInit(),
          this.$container.find(".product-image-area .more-views-verticle")
            .length > 0 &&
            this.$container
              .find(".product-image-area .more-views-verticle")
              .each(function () {
                verticalCarosel($(this));
              }),
          qtyInit();
      }
    );
  })()),
  (theme.CollectionFilterTab = (function () {
    return (
      (this.$container = null),
      function (t) {
        (this.$container = $(t)),
          this.$container.find(".owl-carousel").length > 0 &&
            this.$container.find(".owl-carousel").each(function () {
              carouselSlider($(this));
            }),
          this.$container
            .find(".lazy")
            .lazyload({ effect: "fadeIn", data_attribute: "src" }),
          $('a[data-toggle="tab"]').on("shown.bs.tab", function (t) {
            var e = $(this).attr("href");
            $(e)
              .find("img[data-src]")
              .each(function () {
                $(this).attr("src", $(this).attr("data-src"));
              });
          }),
          this.$container.find(".category-products .products-grid").length >
            0 && productGridSetup(),
          productReview(),
          countDownInit(),
          this.$container.find(".product-image-area .more-views-verticle")
            .length > 0 &&
            this.$container
              .find(".product-image-area .more-views-verticle")
              .each(function () {
                verticalCarosel($(this));
              }),
          qtyInit();
      }
    );
  })()),
  (theme.ProductsMasonryGrid = (function () {
    return (
      (this.$container = null),
      function (t) {
        this.$container = $(t);
        var e = this.$container.find(".products-masonry-grid"),
          i = this.$container.find(".infinite-scrolling").data("show");
        e.length > 0 &&
          (e.imagesLoaded(function () {
            e.show(),
              e.packery({
                itemSelector: ".grid-item",
                columnWidth: ".grid-sizer",
                percentPosition: !0,
              });
          }),
          setTimeout(function () {
            e.animate({ opacity: 1 }, 200);
          }, 1e3)),
          $(t)
            .find(".infinite-scrolling a")
            .click(function () {
              $(this).parent().addClass("loading"),
                $(t).find(".products-grid .item:hidden").length > 0 &&
                  ($(t)
                    .find(".products-grid .item:hidden:lt(" + i + ")")
                    .each(function () {
                      $(this)
                        .find("img[data-src]")
                        .each(function () {
                          $(this).attr("src", $(this).attr("data-src"));
                        }),
                        $(this)
                          .show()
                          .css({ opacity: 1, transition: "opacity 0.3s" }),
                        e.packery("layout");
                    }),
                  $("window").scroll(),
                  0 == $(t).find(".products-grid .item:hidden").length &&
                    $(t)
                      .find(".infinite-scrolling a")
                      .text(frontendData.loadMoreText)),
                setTimeout(function () {
                  $(t).find(".infinite-scrolling").removeClass("loading");
                }, 1e3);
            }),
          this.$container
            .find(".lazy")
            .lazyload({ effect: "fadeIn", data_attribute: "src" }),
          countDownInit();
      }
    );
  })()),
  (theme.slideshows = {}),
  (theme.SlideshowSection = (function () {
    return function (t) {
      var e = (this.$container = $(t)).attr("data-section-id"),
        i = (this.slideshow = "#slideshow-section-" + e);
      theme.slideshows[i] = new theme.Slideshow(i);
    };
  })()),
  (theme.SlideshowSection.prototype = _.assignIn(
    {},
    theme.SlideshowSection.prototype,
    {
      onUnload: function () {
        delete theme.slideshows[this.slideshow];
      },
    }
  )),
  (theme.brandslider = {}),
  (theme.BrandSliderSection = (function () {
    return function (t) {
      var e = (this.$container = $(t)).attr("data-section-id"),
        i = (this.blogtestimonial = "#brands-slider-" + e);
      theme.brandslider[i] = new theme.BrandSlider(i);
    };
  })()),
  (theme.BrandSliderSection.prototype = _.assignIn(
    {},
    theme.BrandSliderSection.prototype,
    {
      onUnload: function () {
        delete theme.brandslider[this.brandslider];
      },
    }
  )),
  (theme.collectionslider = {}),
  (theme.CollectionSliderSection = (function () {
    return function (t) {
      var e = (this.$container = $(t)).attr("data-section-id"),
        i = (this.collectionslider = "#collection-slider-" + e);
      theme.collectionslider[i] = new theme.CollectionSlider(i);
    };
  })()),
  (theme.CollectionSliderSection.prototype = _.assignIn(
    {},
    theme.CollectionSliderSection.prototype,
    {
      onUnload: function () {
        delete theme.collectionslider[this.collectionslider];
      },
    }
  )),
  (theme.collectionproducts = {}),
  (theme.CollectionProductsSection = (function () {
    return function (t) {
      var e = (this.$container = $(t)).attr("data-section-id"),
        i = (this.collectionproducts = "#filter-products-" + e);
      theme.collectionproducts[i] = new theme.CollectionProducts(i);
    };
  })()),
  (theme.CollectionProductsSection.prototype = _.assignIn(
    {},
    theme.CollectionProductsSection.prototype,
    {
      onUnload: function () {
        delete theme.collectionproducts[this.collectionproducts];
      },
    }
  )),
  (theme.collectionfilter = {}),
  (theme.CollectionFillterTabSection = (function () {
    return function (t) {
      var e = (this.$container = $(t)).attr("data-section-id"),
        i = (this.collectionfilter = "#collection-filter-" + e);
      theme.collectionfilter[i] = new theme.CollectionFilterTab(i);
    };
  })()),
  (theme.CollectionFillterTabSection.prototype = _.assignIn(
    {},
    theme.CollectionFillterTabSection.prototype,
    {
      onUnload: function () {
        delete theme.collectionfilter[this.collectionfilter];
      },
    }
  )),
  (theme.productsmasonry = {}),
  (theme.ProductsMasonrySection = (function () {
    return function (t) {
      var e = (this.$container = $(t)).attr("data-section-id"),
        i = (this.productsmasonry = "#filter-products-masonry-" + e);
      theme.productsmasonry[i] = new theme.ProductsMasonryGrid(i);
    };
  })()),
  (theme.ProductsMasonrySection.prototype = _.assignIn(
    {},
    theme.ProductsMasonrySection.prototype,
    {
      onUnload: function () {
        delete theme.productsmasonry[this.productsmasonry];
      },
    }
  )),
  setTimeout(function () {
    var t = new theme.Sections();
    t.register("header-section", theme.HeaderSection),
      t.register("slideshow-section", theme.SlideshowSection),
      t.register("brands-slider-section", theme.BrandSliderSection),
      t.register("collection-slider-section", theme.CollectionSliderSection),
      t.register("filter-products-section", theme.CollectionProductsSection),
      t.register(
        "collection-filter-section",
        theme.CollectionFillterTabSection
      ),
      t.register(
        "filter-products-masonry-section",
        theme.ProductsMasonrySection
      );
  });
var SW = SW || {};
!(function ($) {
  var pixelRatio = window.devicePixelRatio ? window.devicePixelRatio : 1,
    $window = $(window),
    body = $("body"),
    deviceAgent = navigator.userAgent.toLowerCase(),
    isMobileAlt = deviceAgent.match(/(iphone|ipod|ipad|android|iemobile)/),
    imageZoomThreshold = 20,
    loading = !1,
    infinite_loaded_count = 1;
  (SW.megamenu = {
    init: function () {
      $(
        ".main-navigation .top-navigation .static-dropdown .menu-wrap-sub, .main-navigation .top-navigation .m-dropdown .menu-wrap-sub"
      ).each(function () {
        $(this).css("left", "-9999px"), $(this).css("right", "auto");
      }),
        $(".main-navigation")
          .find("li.m-dropdown .menu-wrap-sub ul > li.parent")
          .mouseover(function () {
            var t = $(this).children(".menu-wrap-sub"),
              e = $(window).innerWidth();
            if (t) {
              var i = $(this).offset(),
                n = $(t).outerWidth();
              e <= i.left + $(this).outerWidth() + n
                ? ($(t).css("left", "auto"), $(t).css("right", "100%"))
                : ($(t).css("left", "100%"), $(t).css("right", "auto"));
            }
          }),
        $(".main-navigation")
          .find("li.static-dropdown.parent,li.m-dropdown.parent")
          .mouseover(function () {
            var t = $(this).children(".menu-wrap-sub"),
              e = $(window).innerWidth();
            if (t) {
              var i = $(this).offset(),
                n = $(t).outerWidth();
              e <= i.left + $(this).outerWidth() + n
                ? ($(t).css("left", "auto"), $(t).css("right", "0"))
                : ($(t).css("left", "20px"), $(t).css("right", "auto"));
            }
          }),
        $(window).resize(function () {
          $(
            ".main-navigation .top-navigation .static-dropdown .menu-wrap-sub, .main-navigation .top-navigation .m-dropdown .menu-wrap-sub"
          ).each(function () {
            $(this).css("left", "-9999px"), $(this).css("right", "auto");
          });
        });
    },
  }),
    (SW.page = {
      init: function () {
        if (
          ("resultLoading" != $("body").find("#resultLoading").attr("id") &&
            $("body").append(
              '<div id="resultLoading" style="display:none"><div class="spinner"><div class="circle"></i></div><div class="bg"></div></div>'
            ),
          $("#popup_newsletter").length > 0)
        ) {
          var t = $("#popup_newsletter");
          SW.page.newsletterPopupInit(t);
        }
        (SW.page.setVisualState(),
        $(".smart_input").on("change", function () {
          "use strict";
          SW.page.setVisualState();
        }),
        SW.page.setSelect(),
        $(".carousel-init.owl-carousel").length > 0) &&
          $(".carousel-init.owl-carousel").each(function () {
            carouselSlider($(this));
          });
        $(".checkout-info .shipping a").click(function () {
          $(this).hasClass("collapsed")
            ? $(this).parent().removeClass("closed")
            : $(this).parent().addClass("closed");
        });
      },
      newsletterPopupInit: function (t) {
        $("#popup_newsletter .subcriper_label input").on("click", function () {
          $(this).parent().find("input:checked").length
            ? createCookie("newsletterSubscribe", "true", 1)
            : readCookie("newsletterSubscribe");
        }),
          $("#popup_newsletter .input-box button.button").on(
            "click",
            function () {
              var t = $(this);
              setTimeout(function () {
                t
                  .parent()
                  .find("input#popup-newsletter")
                  .hasClass("validation-failed") ||
                  createCookie("newsletterSubscribe", "true", 1);
              }, 500);
            }
          ),
          null == readCookie("newsletterSubscribe") &&
            setTimeout(function () {
              $.magnificPopup.open({
                items: { src: $("#popup_newsletter"), type: "inline" },
                mainClass: "mfp-move-from-top",
                removalDelay: 200,
                midClick: !0,
              });
            }, newsletterData.delay);
      },
      translateBlock: function (t) {
        multi_language && translator.isLang2() && translator.doTranslate(t);
      },
      translateText: function (t) {
        if (!multi_language || t.indexOf("|") < 0) return t;
        if (multi_language) {
          var e = t.split("|");
          return translator.isLang2() ? e[1] : e[0];
        }
      },
      setVisualState: function () {
        "use strict";
        $(".smart_input").each(function () {
          $(this).val();
          $(this).is(":checked")
            ? $(this).next().addClass("checked")
            : $(this).next().removeClass("checked");
        });
      },
      setSelect: function () {
        "use strict";
        $.isFunction($.fn.selectize) &&
          $(".bootstrap-select").length &&
          $(".bootstrap-select").selectize();
      },
    }),
    (SW.collection = {
      init: function () {
        productGridSetup(),
          SW.collection.layoutSwitch(),
          null != readCookie("products-listmode") &&
            SW.collection.layoutListInit(),
          $(document).on("click", ".close-box", function () {
            $(this).parents(".box-popup").removeClass("show");
          }),
          $(document).on("click", ".add-to-wishlist", function (t) {
            t.preventDefault(), SW.collection.addToWishlist($(this));
          }),
          $(document).on("click", ".remove-wishlist", function (t) {
            t.preventDefault(), SW.collection.removeWishlist($(this));
          }),
          $(document).on("click", ".btn-remove-cart", function (t) {
            t.preventDefault(),
              SW.collection.removeCartInit($(this).data("id"));
          }),
          $(document).on("click", ".filter-bar a", function (t) {
            t.preventDefault(),
              $(".filter-option-group").is(".open")
                ? $(".filter-option-group").removeClass("open")
                : $(".filter-option-group").addClass("open");
          }),
          $(".move-action .item .details-area .actions").each(function () {
            $(this)
              .parents(".item-area")
              .children(".product-image-area")
              .append($(this));
          }),
          $("[data-with-product]").each(function () {
            SW.collection.prevNextProductData($(this));
          }),
          SW.collection.addToCart(),
          SW.collection.quickshopInit(),
          SW.collection.sidebarMenuInit(),
          SW.collection.layerFilterInit(),
          colorSwatchGrid(),
          SW.collection.tabInfinityScrollInit(),
          countDownInit(),
          SW.collection.initInfiniteScrolling(),
          SW.collection.sidebarInitToggle(),
          SW.collection.sidebarCategoryInitToggle(),
          qtyInit();
      },
      animateItems: function (t) {
        t.find(".product").each(function (t) {
          $(this).css("opacity", 1),
            $(this).addClass("item-animated"),
            $(this)
              .delay(200 * t)
              .animate({ opacity: 1 }, 500, "easeOutExpo", function () {
                $(this).addClass("item-animated");
              });
        });
      },
      layoutSwitch: function () {
        var t = !1;
        $(document).on("click", "span.layout-opt", function (e) {
          var i = $("#products-grid"),
            n = $(this).data("layout"),
            o = i.data("columns");
          $(".toolbar .view-mode .layout-opt").removeClass("active"),
            $(this).addClass("active"),
            eraseCookie("products-listmode"),
            null == readCookie("products-listmode") &&
              createCookie("products-listmode", n, 10),
            t ||
              ((t = !0),
              i.animate({ opacity: 0 }, 300),
              setTimeout(function () {
                $("body.template-collection")
                  .removeAttr("class")
                  .addClass("template-collection gm-menu-installed"),
                  $("body.template-collection").addClass("layout-" + n),
                  "grid-extended" == n
                    ? $("body.layout-grid-extended")
                        .find(".products-grid")
                        .removeAttr("class")
                        .addClass("products-grid")
                        .addClass("columns4")
                    : $("body.template-collection")
                        .find(".products-grid")
                        .removeAttr("class")
                        .addClass("products-grid")
                        .addClass("columns" + o),
                  $(".products-grid").length > 0 &&
                    $(".products-grid").children().css("min-height", "0"),
                  productGridSetup(),
                  i.animate({ opacity: 1 }, 200),
                  (t = !1);
              }, 300),
              e.preventDefault());
        });
      },
      layoutListInit: function () {
        var t = $("#products-grid"),
          e = readCookie("products-listmode"),
          i = t.data("columns");
        t.css("opacity", 0),
          $(".toolbar .view-mode span").removeClass("active"),
          $('.toolbar .view-mode span[data-layout="' + e + '"]').addClass(
            "active"
          ),
          $("body.template-collection")
            .removeAttr("class")
            .addClass("template-collection gm-menu-installed"),
          $("body.template-collection").addClass("layout-" + e),
          "grid-extended" == e
            ? $("body.layout-grid-extended")
                .find(".products-grid")
                .removeAttr("class")
                .addClass("products-grid")
                .addClass("columns" + i)
            : $("body.template-collection")
                .find(".products-grid")
                .removeAttr("class")
                .addClass("products-grid")
                .addClass("columns" + i),
          setTimeout(function () {
            t.animate({ opacity: 1 }, 200);
          }, 300);
      },
      productDealInit: function (t) {
        var e = t.data("date");
        if (e) {
          var i = { date: e };
          $.extend(i, countdown),
            $.extend(i, countdownConfig),
            countdownTemplate && (i.template = countdownTemplate),
            t.countdown(i);
        }
      },
      quickshopInit: function () {
        $(document).on("initproduct", "#product-form", function () {
          var t = $(this).data("id"),
            e = $(".product-view");
          Shopify.getProduct(t, function (t) {
            e.find(".product-shop").attr("id", "product-" + t.id),
              e.find(".product-form").attr("id", "product-actions-" + t.id),
              e
                .find(".product-form .product-options select")
                .attr("id", "product-select-" + t.id),
              SW.collection.createSwatch(t, e);
          });
        }),
          $("#product-form").trigger("initproduct"),
          $(document).on("click", ".quickview", function () {
            var $prod = $(this).closest(".product");
            eval($prod.find("[data-id^=product-block-json-]").html());
            var template = $prod
              .find("[data-id^=product-block-template-]")
              .html();
            return $.magnificPopup.open({
              items: { src: [template].join(""), type: "inline" },
              mainClass: "mfp-move-from-top",
              removalDelay: 200,
              midClick: !0,
              preloader: !0,
              callbacks: {
                open: function () {
                  (SW.verticleScroll.init(),
                  $(".carousel-init.owl-carousel").length > 0) &&
                    $(".carousel-init.owl-carousel").each(function () {
                      carouselSlider($(this));
                    });
                  SW.productMediaManager.init(),
                    $("#product-form").trigger("initproduct"),
                    countDownInit(),
                    SW.page.translateBlock(".quick-view"),
                    frontendData.enableCurrency &&
                      currenciesCallbackSpecial(".quick-view span.money"),
                    productReview();
                },
                close: function () {
                  SW.productMediaManager.destroyZoom();
                },
              },
            });
          });
      },
      createSwatch: function (t, e) {
        if (t.variants.length >= 1) {
          for (var i = 0; i < t.variants.length; i++) {
            var n =
              '<option value="' +
              (d = t.variants[i]).id +
              '">' +
              d.title +
              "</option>";
            e.find("form.product-form > select").append(n);
          }
          new Shopify.OptionSelectors("product-select-" + t.id, {
            product: t,
            onVariantSelected: SW.collection.selectCallback,
          });
          var o = asset_url.substring(0, asset_url.lastIndexOf("/")),
            a = asset_url.substring(0, asset_url.lastIndexOf("/")),
            r = "";
          for (i = 0; i < t.options.length; i++) {
            (r +=
              '<div class="swatch clearfix" data-option-index="' + i + '">'),
              (r += '<div class="header">' + t.options[i].name + "</div>");
            var s = !1;
            /Color|Colour/i.test(t.options[i].name) && (s = !0);
            for (var c = new Array(), l = 0; l < t.variants.length; l++) {
              var d,
                u = (d = t.variants[l]).options[i],
                p = SW.collection.convertToSlug(u),
                h = "swatch-" + i + "-" + p;
              c.indexOf(u) < 0 &&
                ((r +=
                  '<div data-value="' +
                  u +
                  '" class="swatch-element ' +
                  (s ? "color" : "") +
                  " " +
                  (s ? "color" : "") +
                  p +
                  (d.available ? " available " : " soldout ") +
                  '">'),
                s && (r += '<div class="tooltip">' + u + "</div>"),
                (r +=
                  '<input id="' +
                  h +
                  '" type="radio" name="option-' +
                  i +
                  '" value="' +
                  u +
                  '" ' +
                  (0 == l ? " checked " : "") +
                  (d.available ? "" : " disabled") +
                  " />"),
                (r += s
                  ? '<label for="' +
                    h +
                    '" style="background-color: ' +
                    p +
                    "; background-image: url(" +
                    o +
                    p +
                    '.png)"><img class="crossed-out" src="' +
                    a +
                    'soldout.png" /></label>'
                  : '<label for="' +
                    h +
                    '">' +
                    u +
                    '<img class="crossed-out" src="' +
                    a +
                    'soldout.png" /></label>'),
                (r += "</div>"),
                d.available &&
                  $(
                    '.product-view .swatch[data-option-index="' + i + '"] .' + p
                  )
                    .removeClass("soldout")
                    .addClass("available")
                    .find(":radio")
                    .removeAttr("disabled"),
                c.push(u));
            }
            r += "</div>";
          }
          swatch_color_enable &&
            (e.find("form.product-form .product-options > select").after(r),
            e.find(".swatch :radio").change(function () {
              var t = $(this).closest(".swatch").attr("data-option-index"),
                e = $(this).val();
              $(this)
                .closest("form")
                .find(".single-option-selector")
                .eq(t)
                .val(e)
                .trigger("change");
            })),
            t.available &&
              ((Shopify.optionsMap = {}), Shopify.linkOptionSelectors(t));
        } else {
          e.find("form.product-form .product-options > select").remove();
          var m =
            '<input type="hidden" name="id" value="' + t.variants[0].id + '">';
          e.find("form.product-form").append(m);
        }
      },
      convertToSlug: function (t) {
        return t
          .toLowerCase()
          .replace(/[^a-z0-9 -]/g, "")
          .replace(/\s+/g, "-")
          .replace(/-+/g, "-");
      },
      selectCallback: function (t, e) {
        if (
          t &&
          (t.available
            ? (t.compare_at_price > t.price
                ? $("#price").html(
                    '<div class="price">' +
                      Shopify.formatMoney(t.price, money_format) +
                      '</div><del class="price_compare">' +
                      Shopify.formatMoney(t.compare_at_price, money_format) +
                      "</del>"
                  )
                : $("#price").html(
                    '<div class="price">' +
                      Shopify.formatMoney(t.price, money_format) +
                      "</div>"
                  ),
              frontendData.enableCurrency &&
                currenciesCallbackSpecial("#price span.money"),
              $(".product-shop-wrapper .add-to-cart")
                .removeClass("disabled")
                .removeAttr("disabled")
                .html(window.inventory_text.add_to_cart),
              t.inventory_management && t.inventory_quantity <= 0
                ? ($("#selected-variant").html(
                    e.product.title + " - " + t.title
                  ),
                  $("#backorder").removeClass("hidden"))
                : $("#backorder").addClass("hidden"),
              null != t.inventory_management
                ? $(".product-inventory span.in-stock").text(
                    window.inventory_text.in_stock
                  )
                : $(".product-inventory span.in-stock").text(
                    window.inventory_text.many_in_stock
                  ),
              $(".product-sku span.sku").text(t.sku))
            : ($("#backorder").addClass("hidden"),
              $(".product-shop-wrapper .add-to-cart")
                .html(window.inventory_text.sold_out)
                .addClass("disabled")
                .attr("disabled", "disabled"),
              $(".product-inventory span.in-stock").text(
                window.inventory_text.out_of_stock
              ),
              $(".product-sku span.sku").empty()),
          swatch_color_enable)
        )
          for (
            var i = $("#" + e.domIdPrefix).closest("form"),
              n = 0,
              o = t.options.length;
            n < o;
            n++
          ) {
            var a = i.find(
              '.swatch[data-option-index="' +
                n +
                '"] :radio[value="' +
                t.options[n] +
                '"]'
            );
            a.size() && (a.get(0).checked = !0);
          }
        if (t && t.featured_image) {
          var r = Shopify.Image.removeProtocol(t.featured_image.src);
          $(".product-image-thumbs .thumb-link")
            .filter('[data-zoom-image="' + r + '"]')
            .trigger("click");
        }
        t && t.sku
          ? $("#sku").removeClass("hidden").find("span").html(t.sku)
          : $("#sku").addClass("hidden").find("span").html("");
      },
      prevNextProductData: function (t) {
        var e = t.data("with-product"),
          i = t.find('script[type="text/template"]'),
          n = i.html();
        $.getJSON("/products/" + e + ".json", function (t) {
          var e = t.product;
          for (var o in e)
            n = n.replace(new RegExp("\\[" + o + "\\]", "ig"), e[o]);
          var a = e.image.src.lastIndexOf(".");
          (n = n.replace(
            /\[img:([a-z]*)\]/gi,
            e.image.src.slice(0, a) + "_$1" + e.image.src.slice(a)
          )),
            i.replaceWith(n);
        });
      },
      addToWishlist: function (t) {
        var e = t.parents("form").serialize(),
          i = t.data("id"),
          n = $("body").find(".wishlist-" + i + " .add-to-wishlist");
        $.ajax({
          type: "POST",
          url: "/contact",
          async: !0,
          data: e,
          cache: !1,
          beforeSend: function () {
            $("#resultLoading").show();
          },
          success: function () {
            var e = t.closest(".product"),
              i = $("#wishlist-box");
            i
              .find(".product-link")
              .attr("href", e.find(".product-name a").attr("href")),
              i
                .find(".product-img")
                .attr("src", e.find(".product-image img").attr("src"))
                .attr("alt", e.find(".product-name a").html()),
              i
                .find(".product-title .product-link")
                .html(e.find(".product-name a").html()),
              i.find(".product-price").html(e.find(".price").html()),
              n.each(function () {
                $(this)
                  .removeClass("add-to-wishlist")
                  .addClass("added")
                  .attr("title", $(this).attr("data-added")),
                  $(this).find("span").html($(this).attr("data-added"));
              }),
              setTimeout(function () {
                $("#resultLoading").hide(),
                  i.addClass("show"),
                  setTimeout(function () {
                    i.removeClass("show");
                  }, 5e3);
              }, 500);
          },
          error: function (t) {
            var e = $("#error-notice"),
              i = $.parseJSON(t.responseText);
            e.find(".heading").html(i.message),
              e.find(".message").html(i.description),
              setTimeout(function () {
                $("#resultLoading").hide(),
                  e.addClass("show"),
                  setTimeout(function () {
                    e.removeClass("show");
                  }, 5e3);
              }, 500);
          },
        });
      },
      removeWishlist: function (e) {
        var i = e.parents("form").serialize(),
          n = e.parents(".item");
        $.ajax({
          type: "POST",
          url: "/contact",
          data: i,
          beforeSend: function () {
            $("#resultLoading").show();
          },
          success: function () {
            $("#resultLoading").hide(), n.fadeOut(500);
          },
          error: function () {
            var e = $("#error-notice"),
              i = $.parseJSON(t.responseText);
            e.find(".heading").html(i.message),
              e.find(".message").html(i.description),
              setTimeout(function () {
                $("#resultLoading").hide(),
                  e.addClass("show"),
                  setTimeout(function () {
                    e.removeClass("show");
                  }, 5e3);
              }, 500);
          },
        });
      },
      addToCart: function () {
        $(document).on("click", ".add-to-cart", function (t) {
          t.preventDefault();
          var e = $(this),
            i = e.closest("form");
          return $.ajax({
            type: "POST",
            url: "/cart/add.js",
            async: !0,
            data: i.serialize(),
            dataType: "json",
            beforeSend: function () {
              e.parents(".item-area").length > 0
                ? e.parents(".item-area").find(".loader-container").show()
                : $("#resultLoading").show();
            },
            error: function (t) {
              var e = $("#error-notice"),
                i = $.parseJSON(t.responseText);
              e.find(".heading").html(i.message),
                e.find(".message").html(i.description),
                setTimeout(function () {
                  $(".loader-container").hide(),
                    $("#resultLoading").hide(),
                    e.addClass("show"),
                    setTimeout(function () {
                      e.removeClass("show");
                    }, 5e3);
                }, 500);
            },
            success: function (t) {
              return (
                Shopify.getCart(function (e) {
                  parseInt(i.find('input[name="quantity"]').val());
                  var n = $("#cart-box");
                  n.find(".product-link").attr("href", t.url),
                    n
                      .find(".product-img")
                      .attr("src", Shopify.resizeImage(t.image, "medium"))
                      .attr("alt", SW.page.translateText(t.title)),
                    n
                      .find(".product-title .product-link")
                      .html(SW.page.translateText(t.title)),
                    n
                      .find(".product-price")
                      .html(Shopify.formatMoney(t.price, money_format)),
                    frontendData.enableCurrency &&
                      currenciesCallbackSpecial("#cart-box span.money"),
                    setTimeout(function () {
                      $(".loader-container").hide(),
                        $("#resultLoading").hide(),
                        n.addClass("show"),
                        setTimeout(function () {
                          n.removeClass("show");
                        }, 5e3);
                    }, 500),
                    SW.collection.updateCartInfo(
                      e,
                      ".cart-container .cart-wrapper .cart-inner-content"
                    );
                }),
                !1
              );
            },
            cache: !1,
          });
        });
      },
      updateCartInfo: function (t, e) {
        var i = $(e),
          n = $(".icon-cart-header .price"),
          o = $(".icon-cart-header .cart-total");
        i.length &&
          (i.empty(),
          n.empty(),
          $.each(t, function (e, a) {
            if ("items" == e) {
              var r = "";
              a.length
                ? (n.html(Shopify.formatMoney(t.total_price, money_format)),
                  o.html(
                    '<span class="cart-qty">' +
                      t.item_count +
                      '</span><span class="cart-price">' +
                      cartData.totalNumb +
                      '<span class="price">' +
                      Shopify.formatMoney(t.total_price, money_format) +
                      "</span></span>"
                  ),
                  (r += '<div class="cart-content">'),
                  $(".header-container").hasClass("type20") &&
                    ((r += '<div class="total-count">'),
                    (r +=
                      "<span>" +
                      t.item_count +
                      " " +
                      cartData.totalNumb +
                      "</span>"),
                    (r +=
                      '<a href="/cart" class="btn-button view-cart bordered uppercase"><span>' +
                      cartData.buttonViewCart +
                      "</span></a>"),
                    (r += "</div>")),
                  (r += '<ul class="clearfix">'),
                  $.each(a, function (t, e) {
                    (r += '<li class="item-cart">'),
                      (r +=
                        '<a class="product-image" href="' +
                        e.url +
                        '"><img alt="' +
                        SW.page.translateText(e.title) +
                        '" src="' +
                        Shopify.resizeImage(e.image, "small") +
                        '" /></a>'),
                      (r +=
                        '<div class="product-details row-fluid show-grid">'),
                      (r +=
                        '<p class="product-name"><a href="' +
                        e.url +
                        '"><span>' +
                        SW.page.translateText(e.title) +
                        "</span></a></p>"),
                      (r +=
                        '<div class="items"><span class="price">' +
                        e.quantity +
                        ' × <span class="amount">' +
                        Shopify.formatMoney(e.price, money_format) +
                        "</span></span></div>"),
                      (r +=
                        '<div class="access"><a href="javascript: void(0);" class="btn-remove btn-remove-cart" data-id="' +
                        e.variant_id +
                        '" title="' +
                        cartData.removeItemLabel +
                        '"><i class="icon-cancel"></i></a></div>'),
                      (r += "</div>"),
                      (r += "</li>");
                  }),
                  (r += "</ul>"),
                  (r += "</div>"),
                  (r += '<div class="cart-checkout">'),
                  (r +=
                    '<div class="cart-info"><p class="subtotal"><span class="label">' +
                    cartData.totalLabel +
                    '</span><span class="price">' +
                    Shopify.formatMoney(t.total_price, money_format) +
                    "</span></p></div>"),
                  (r += '<div class="actions">'),
                  $(".header-container").hasClass("type20")
                    ? (r +=
                        '<a href="/checkout" class="btn-button checkout-cart bordered uppercase"><span>' +
                        cartData.buttonCheckout +
                        "</span></a>")
                    : ((r +=
                        '<a href="/cart" class="btn-button view-cart"><span>' +
                        cartData.buttonViewCart +
                        "</span></a> "),
                      (r +=
                        '<a href="/checkout" class="btn-button checkout-cart"><span>' +
                        cartData.buttonCheckout +
                        "</span></a>")),
                  (r += "</div>"),
                  (r += "</div>"))
                : (n.html(Shopify.formatMoney(t.total_price, money_format)),
                  o.html(
                    '<span class="cart-qty">' +
                      t.item_count +
                      "</span><span>" +
                      cartData.totalNumb +
                      "</span>"
                  ),
                  (r += '<div class="cart-content">'),
                  (r +=
                    '<p class="no-items-in-cart">' +
                    cartData.noItemLabel +
                    "</p>"),
                  (r += "</div>"));
            }
            i.append(r);
          })),
          $(".icon-cart-header .cart-count").length > 0 &&
            $(".icon-cart-header .cart-count").html(t.item_count),
          frontendData.enableCurrency &&
            (currenciesCallbackSpecial(".cart-wrapper .cart-inner span.money"),
            currenciesCallbackSpecial(".icon-cart-header span.money"));
      },
      removeCartInit: function (t, e) {
        $.ajax({
          type: "POST",
          url: "/cart/change.js",
          data: "quantity=0&id=" + t,
          dataType: "json",
          beforeSend: function () {
            $(".cartloading").show();
          },
          success: function (t) {
            "function" == typeof e
              ? e(t)
              : (SW.collection.updateCartInfo(
                  t,
                  ".cart-container .cart-wrapper .cart-inner-content"
                ),
                $(".cartloading").hide());
          },
          error: function (t, e) {
            Shopify.onError(t, e);
          },
        });
      },
      sidebarMenuInit: function () {
        $("#mobile-menu, #categories_nav").mobileMenu({
          accordion: !0,
          speed: 400,
          closedSign: "collapse",
          openedSign: "expand",
          mouseType: 0,
          easing: "easeInOutQuad",
        });
      },
      sortbyFilter: function () {
        $(document).on("change", ".sort-by .field", function (t) {
          t.preventDefault();
          var e = $(this).val();
          (Shopify.queryParams.sort_by = e), SW.collection.filterAjaxRequest();
        });
      },
      limitedAsFilter: function () {
        $(document).on("change", ".limited-view .field", function (t) {
          t.preventDefault();
          var e = $(this).val();
          (Shopify.queryParams.view = e), SW.collection.filterAjaxRequest();
        });
      },
      swatchListFilter: function () {
        $(document).on(
          "click",
          ".narrow-by-list .item:not(.disable), .advanced-filter .field:not(.disable)",
          function () {
            var t = $(this),
              e = t.find("input").val(),
              i = [];
            if (
              (Shopify.queryParams.constraint &&
                (i = Shopify.queryParams.constraint.split("+")),
              !t.hasClass("active"))
            ) {
              var n = t
                .parents(".layer-filter, .advanced-filter")
                .find(".active");
              n.length > 0 &&
                n.each(function () {
                  var t = $(this).data("handle");
                  if (($(this).removeClass("active"), t)) {
                    var e = i.indexOf(t);
                    e >= 0 && i.splice(e, 1);
                  }
                });
            }
            if (e) {
              var o = i.indexOf(e);
              0 > o
                ? (i.push(e), t.addClass("active"))
                : (i.splice(o, 1), t.removeClass("active"));
            }
            i.length
              ? (Shopify.queryParams.constraint = i.join("+"))
              : delete Shopify.queryParams.constraint,
              SW.collection.filterAjaxRequest();
          }
        );
      },
      paginationActionInit: function () {
        $(document).on("click", ".pagination-page a", function (t) {
          var e = $(this)
            .attr("href")
            .match(/page=\d+/g);
          if (
            e &&
            ((Shopify.queryParams.page = parseInt(e[0].match(/\d+/g))),
            Shopify.queryParams.page)
          ) {
            var i = SW.collection.filterCreateUrl();
            History.pushState({ param: Shopify.queryParams }, i, i),
              SW.collection.filterGetContent(i);
          }
          t.preventDefault();
        });
      },
      layerFilterInit: function () {
        SW.collection.sortbyFilter(),
          SW.collection.limitedAsFilter(),
          SW.collection.paginationActionInit(),
          SW.collection.swatchListFilter(),
          SW.collection.layerClearAllFilter(),
          SW.collection.layerClearFilter();
      },
      filterCreateUrl: function (t) {
        var e = $.param(Shopify.queryParams).replace(/%2B/g, "+");
        return t ? ("" != e ? t + "?" + e : t) : location.pathname + "?" + e;
      },
      filterAjaxRequest: function (t) {
        delete Shopify.queryParams.page;
        var e = SW.collection.filterCreateUrl(t);
        History.pushState({ param: Shopify.queryParams }, e, e),
          SW.collection.filterGetContent(e);
      },
      filterGetContent: function (t) {
        $.ajax({
          type: "get",
          url: t,
          beforeSend: function () {
            $("#resultLoading").show();
          },
          success: function (e) {
            infinite_loaded_count = 0;
            var i = e.match("<title>(.*?)</title>")[1];
            $("#collection-main")
              .empty()
              .html($(e).find("#collection-main").html()),
              $(".narrow-by-list")
                .empty()
                .html($(e).find(".narrow-by-list").html()),
              $(".pagination").empty().html($(e).find(".pagination").html()),
              $(".main-breadcrumbs")
                .empty()
                .html($(e).find(".main-breadcrumbs").html()),
              History.pushState({ param: Shopify.queryParams }, i, t),
              setTimeout(function () {
                var headerHeight = $(".header-container").outerHeight();
                $("html,body").animate(
                  {
                    scrollTop: $(".toolbar").offset().top - (headerHeight + 20),
                  },
                  500
                );
              }, 100),
              $("#resultLoading").hide(),
              null != readCookie("products-listmode") &&
                SW.collection.layoutListInit(),
              productGridSetup(),
              SW.collection.layerClearFilter(),
              SW.collection.layerClearAllFilter(),
              colorSwatchGrid(),
              SW.page.setVisualState(),
              SW.collection.initInfiniteScrolling(),
              SW.page.setSelect(),
              SW.collection.sidebarInitToggle(),
              SW.page.translateBlock(".main-wrapper"),
              productReview(),
              frontendData.enableCurrency &&
                currenciesCallbackSpecial(".products-grid span.money");
          },
          error: function () {
            $("#resultLoading").hide();
          },
        });
      },
      sidebarInitToggle: function () {
        $(".sidebar-toogle").length > 0 &&
          $(".sidebar-toogle .block-title span.collapse").click(function () {
            $(this).hasClass("click")
              ? ($(this).removeClass("click"),
                $(this).parent().removeClass("closed"))
              : ($(this).parent().addClass("closed"),
                $(this).addClass("click")),
              $(this)
                .parents(".sidebar-toogle")
                .find(".sidebar-content")
                .slideToggle();
          });
      },
      sidebarCategoryInitToggle: function () {
        $(".sidebar-cate-toogle").length > 0 &&
          $(".sidebar-cate-toogle .block-title span.collapse").click(
            function () {
              $(this).hasClass("click")
                ? ($(this).removeClass("click"),
                  $(this).parent().removeClass("closed"))
                : ($(this).parent().addClass("closed"),
                  $(this).addClass("click")),
                $(this)
                  .parents(".sidebar-cate-toogle")
                  .find(".sidebar-content")
                  .slideToggle();
            }
          );
      },
      layerClearFilter: function () {
        $(".narrow-by-list .narrow-item").each(function () {
          var t = $(this);
          t.find("input:checked").length > 0 &&
            t.find(".clear").click(function (e) {
              var i = [];
              Shopify.queryParams.constraint &&
                (i = Shopify.queryParams.constraint.split("+")),
                t.find("input:checked").each(function () {
                  var t = jQuery(this).val();
                  if (t) {
                    var e = i.indexOf(t);
                    e >= 0 && i.splice(e, 1);
                  }
                }),
                i.length
                  ? (Shopify.queryParams.constraint = i.join("+"))
                  : delete Shopify.queryParams.constraint,
                SW.collection.filterAjaxRequest(),
                e.preventDefault();
            });
        });
      },
      layerClearAllFilter: function () {
        $(document).on(
          "click",
          ".narrow-by-list .clearall, .filter-option-inner .clearall",
          function (t) {
            t.preventDefault(),
              delete Shopify.queryParams.constraint,
              delete Shopify.queryParams.q,
              SW.collection.filterAjaxRequest();
          }
        );
      },
      tabInfinityScrollInit: function () {
        var t = $(".tab-content .category-products"),
          e = t.find(".data-tab").data("limit"),
          n = t.find(".data-tab").data("show"),
          o = t.find(".data-tab").data("text"),
          a = t.find(".data-tab").data("translate"),
          r = t.find(".products-grid .item").length;
        if (t.find(".data-tab").data("showmore")) {
          for (console.log(n), i = 0; i <= r; i++) i > n && console.log(i);
          r > e &&
            (($mainsc = $("<div/>").addClass(
              "infinite-scrolling-homepage wow fadeIn"
            )),
            ($in = $("<span/>")
              .addClass("sc-show-more")
              .attr("data-translate", a)
              .text(o)
              .appendTo($mainsc)),
            t.append($mainsc));
        }
      },
      initInfiniteScrolling: function () {
        $(window).scroll(function () {
          $(".infinite-loader").length > 0 &&
            $(window).scrollTop() >=
              $(".infinite-loader").offset().top - $(window).height() + 100 &&
            infinite_loaded_count < 2 &&
            $(".infinite-loader a").trigger("click");
        }),
          $(".infinite-loader").length > 0 &&
            $(".infinite-loader a").click(function (t) {
              t.preventDefault(),
                $(this).hasClass("disabled") ||
                  SW.collection.doInfiniteScrolling();
            });
      },
      doInfiniteScrolling: function () {
        var t = $("#collection-main .products-grid"),
          e = $("#products-grid");
        if (((infinite_loaded_count += 1), t)) {
          var i = $(".infinite-loader a").first();
          $.ajax({
            type: "GET",
            url: i.attr("href"),
            beforeSend: function () {
              $(".infinite-loader .btn-load-more").hide(),
                $(".infinite-loader .loading").fadeIn(300);
            },
            success: function (n) {
              loading = !1;
              var o = $(n).find("#collection-main .products-grid .item");
              o.length > 0 &&
                (e.append(o),
                SW.page.translateBlock("." + t.attr("class")),
                $(n).find(".infinite-loader").length > 0
                  ? (i.attr(
                      "href",
                      $(n).find(".infinite-loader a").attr("href")
                    ),
                    infinite_loaded_count >= 2
                      ? ($(".infinite-loader .loading").fadeOut(300),
                        $(".infinite-loader .btn-load-more").show())
                      : $(".infinite-loader .loading").fadeOut(300))
                  : ($(".infinite-loader .loading").fadeOut(300), i.hide()),
                null != readCookie("products-listmode") &&
                  SW.collection.layoutListInit(),
                productGridSetup(),
                SW.collection.layerClearFilter(),
                SW.collection.layerClearAllFilter(),
                colorSwatchGrid(),
                SW.page.setVisualState(),
                frontendData.enableCurrency &&
                  currenciesCallbackSpecial(".products-grid span.money"),
                productReview());
            },
            error: function (t, e) {
              $(".infinite-loader .btn-load-more").hide(),
                $(".infinite-loader .loading").fadeOut(300);
            },
            dataType: "html",
          });
        }
      },
    }),
    (SW.productMediaManager = {
      destroyZoom: function () {
        $(".zoomContainer").remove(),
          $(".product-image-gallery .gallery-image").removeData("elevateZoom");
      },
      createZoom: function (t) {
        if (
          (SW.productMediaManager.destroyZoom(),
          !(isMobileAlt || t.length <= 0))
        ) {
          if (t[0].naturalWidth && t[0].naturalHeight) {
            var e = t[0].naturalWidth - t.width() - imageZoomThreshold,
              i = t[0].naturalHeight - t.height() - imageZoomThreshold;
            if (e < 0 && i < 0)
              return void t
                .parents(".product-image")
                .removeClass("zoom-available");
            t.parents(".product-image").addClass("zoom-available");
          }
          "inside" == dataZoom.position
            ? t.elevateZoom({
                zoomType: "inner",
                easing: !0,
                cursor: "crosshair",
              })
            : t.elevateZoom({
                zoomWindowPosition: 1,
                easing: !0,
                zoomWindowFadeIn: 500,
                zoomWindowFadeOut: 500,
                lensFadeIn: 500,
                lensFadeOut: 500,
                borderSize: 3,
                lensBorderSize: 2,
                lensBorderColour: "#999",
                borderColour: "#ddd",
              }),
            dataZoom.lightbox &&
              t.bind("click", function (e) {
                var i = t.data("elevateZoom");
                return i.closeAll(), $.fancybox(i.getGalleryList()), !1;
              });
        }
      },
      swapImage: function (t) {
        (t = $(t)).addClass("gallery-image"),
          SW.productMediaManager.destroyZoom();
        var e = $(".product-image-gallery");
        t[0].complete
          ? (e.find(".gallery-image").removeClass("visible"),
            e.append(t),
            t.addClass("visible"),
            SW.productMediaManager.createZoom(t))
          : (e.addClass("loading"),
            e.append(t),
            imagesLoaded(t, function () {
              e.removeClass("loading"),
                e.find(".gallery-image").removeClass("visible"),
                t.addClass("visible"),
                SW.productMediaManager.createZoom(t);
            }));
      },
      wireThumbnails: function () {
        $(".product-image-thumbs .thumb-link").click(function (t) {
          t.preventDefault();
          var e = $(this),
            i = $("#image-" + e.data("image-index"));
          SW.productMediaManager.swapImage(i);
        });
      },
      initZoom: function () {
        SW.productMediaManager.createZoom($(".gallery-image.visible"));
      },
      init: function () {
        (SW.productMediaManager.imageWrapper = $(".product-img-box")),
          $(window).resize(function () {
            SW.productMediaManager.initZoom();
          }),
          SW.productMediaManager.initZoom(),
          SW.productMediaManager.wireThumbnails();
      },
    }),
    (SW.verticleScroll = {
      init: function () {
        if ($(".product-img-box .verticl-carousel").length > 0) {
          var t = $(".product-img-box .verticl-carousel");
          SW.verticleScroll.carouselInit(t);
        }
      },
      carouselInit: function (t) {
        t.find("a").length <= 3 &&
          t.parents(".more-views-verticle").find(".more-views-nav").hide(),
          $(".product-img-box #carousel-up").on("click", function () {
            if (!$(".product-img-box .verticl-carousel").is(":animated")) {
              var t = $(".product-img-box .verticl-carousel > a:last-child");
              $(".product-img-box .verticl-carousel > a:last-child")
                .clone()
                .prependTo(".product-img-box .verticl-carousel"),
                $(".product-img-box .verticl-carousel")
                  .animate({ top: "-=90" }, 0)
                  .stop()
                  .animate({ top: "+=90" }, 300, function () {
                    t.remove();
                  }),
                SW.productMediaManager.init();
            }
          }),
          $(".product-img-box #carousel-down").on("click", function () {
            if (!$(".product-img-box .verticl-carousel").is(":animated")) {
              var t = $(".product-img-box .verticl-carousel > a:first-child");
              $(".product-img-box .verticl-carousel > a:first-child")
                .clone()
                .appendTo(".product-img-box .verticl-carousel"),
                $(".product-img-box .verticl-carousel").animate(
                  { top: "-=90" },
                  300,
                  function () {
                    t.remove(),
                      $(".product-img-box .verticl-carousel").animate(
                        { top: "+=90" },
                        0
                      );
                  }
                ),
                SW.productMediaManager.init();
            }
          });
      },
    }),
    (SW.footer = {
      init: function () {
        SW.footer.backToTopInit();
      },
      backToTopInit: function () {
        $(window).scroll(function () {
          $(this).scrollTop() > 100
            ? $("#back-top").fadeIn()
            : $("#back-top").fadeOut();
        }),
          $("#back-top a").click(function () {
            return $("body,html").animate({ scrollTop: 0 }, 800), !1;
          });
      },
    }),
    (SW.onReady = {
      init: function () {
        SW.megamenu.init(),
          SW.page.init(),
          SW.collection.init(),
          SW.footer.init(),
          SW.verticleScroll.init(),
          SW.productMediaManager.init();
      },
    }),
    (SW.onLoad = { init: function () {} }),
    setTimeout(function () {
      SW.onReady.init();
    }),
    setTimeout(function () {
      SW.onLoad.init();
    });
})(jQuery);
Shopify.Cart.ShippingCalculator.show({
  submitButton: theme.strings.shippingCalcSubmitButton || undefined,
  submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
  customerIsLoggedIn: theme.strings.shippingCalcCustomerIsLoggedIn,
  moneyFormat: theme.strings.shippingCalcMoneyFormat,
});
